// extracted by mini-css-extract-plugin
export default {"wrapper":"InActiveSellers_wrapper__lFGbR","txt":"InActiveSellers_txt__++0-N","icon":"InActiveSellers_icon__P6oVX","createSeller":"InActiveSellers_createSeller__Oehvx"};